import type { FaireProductEntity } from "../../entity_types/product";

export const p_qwdqk3ppdj: FaireProductEntity = {
  token: "p_qwdqk3ppdj",
  type: "product",
  name: "5 Heart Zircon Side by Side 18K Gold Plated SS Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/089286c4eaf6e17fd9a1604a08569afc3dae29bb22ae6a28b7f1bfca827f1239.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0928249e8e1cc2f51ac8e99f6703eac0044f5add1e03a5b2194a1ad85b1b201.jpeg",
    "https://cdn.faire.com/fastly/9035aaeb360b8e81454db72644a10dda1799840b7788b306ddd6c3d8cc9d4793.jpeg",
    "https://cdn.faire.com/fastly/d931949e783b0c5353684f1f7fc1e860a5ce900f2bed57b06719afeccaacd260.jpeg",
  ],
  priceDollars: 8.48,
  description:
    "Type: Ring\nMaterial : Stainless steel ,Cubic zirconia,18K gold plated\nSize : Width - 5.7mm\nProcess: Vacuum electroplating and manual polishing\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry g",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:22.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
